import { Inject, Injectable } from '@angular/core';
import { SERVICES_ENV, SharedServicesEnvironment } from '@benefits/shared-services';
import { NGXLogger } from 'ngx-logger';

export interface TelemetryEvent {
    /** The URL the browser was at when this event was logged. */
    url: string;

    /** The elapsed time for this event, if any. */
    elapsedMs?: number;

    /** A category for the event, like ForgeRockEvent or FetchTookWayTooLongEvent */
    category: string;

    /** All of the other properties in the object the user gave us. */
    [key: string]: any

}

/**
 * Some abstractions for ngx-logger.
 */
@Injectable()
export class TelemetryService {
    constructor(@Inject(SERVICES_ENV) private environment: SharedServicesEnvironment, private logger: NGXLogger) {
        // Configure ngx-logger.
        this.logger.updateConfig({
            serverLoggingUrl: environment.telemetryServerUrl,
            level: environment.consoleTelemetryLevel,
            serverLogLevel: environment.serverTelemetryLevel,
            httpResponseType: 'text',
        })
    }

    /**
     * Log a "info" level event.
     * @param payload A JSON stringifiable object full of properties we want to log (which will be merged into the event's payload)
     * @param category A category for the event to help us sort, like ForgeRockEvent or ImATeapotEvent
     * @param elapsedMs The elapsed time in milliseconds for the operation we're logging, if you have it.
     */
    logInfo(payload: {[key: string]: any}, category: string, elapsedMs?: number) {
        const currentUrl = window.location.href;
        const logEvent: TelemetryEvent = {
            ...payload,
            category,
            elapsedMs,
            url: currentUrl,
        }
        this.logger.info(JSON.stringify(logEvent));
    }
    /**
     * Log a "warning" level event.
     * @param payload A JSON stringifiable object full of properties we want to log (which will be merged into the event's payload)
     * @param category A category for the event to help us sort, like ForgeRockEvent or ImATeapotEvent
     * @param elapsedMs The elapsed time in milliseconds for the operation we're logging, if you have it.
     */
     logWarning(payload: {[key: string]: any}, category: string, elapsedMs?: number) {
        const currentUrl = window.location.href;
        const logEvent: TelemetryEvent = {
            ...payload,
            category,
            elapsedMs,
            url: currentUrl,
        }
        this.logger.warn(JSON.stringify(logEvent));
    }

    /**
     * Log a "error" level event.
     * @param payload A JSON stringifiable object full of properties we want to log (which will be merged into the event's payload)
     * @param category A category for the event to help us sort, like ForgeRockEvent or ImATeapotEvent
     * @param elapsedMs The elapsed time in milliseconds for the operation we're logging, if you have it.
     */
     logError(payload: {[key: string]: any}, category: string, elapsedMs?: number) {
        const currentUrl = window.location.href;
        const logEvent: TelemetryEvent = {
            ...payload,
            category,
            elapsedMs,
            url: currentUrl,
        }
        this.logger.error(JSON.stringify(logEvent));
    }

}
